import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';

type Props = {
  inputId: string;
  label: string;
  error: boolean;
  errorMessage: string;
  children: React.ReactNode;
};

const BaseInputWrapper = ({
  inputId,
  label,
  error,
  errorMessage,
  children,
}: Props): JSX.Element => (
  <FormControl data-testid="base-input-wrapper" fullWidth error={error}>
    <InputLabel data-testid="base-input-wrapper-label" htmlFor={inputId} shrink>
      {label}
    </InputLabel>
    {children}
    <FormHelperText
      data-testid="base-input-wrapper-helper"
      id={`${inputId}-helper`}
    >
      {errorMessage}
    </FormHelperText>
  </FormControl>
);

export default BaseInputWrapper;
